import * as types from '../mutation-types'

export const state = {
  config: getSavedState('chirhos.config'),
}

export const mutations = {
  [types.SET_CHIRHOS_CONFIG](state, newValue) {
    state.config = newValue
    saveState('chirhos.config', newValue)
  },
}

export const actions = {
  saveConfig({ commit }, config) {
    commit(types.SET_CHIRHOS_CONFIG, config)
  },
}

// ===
// Private helpers
// TODO: Move to helper
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
